import {type ReactElement, useEffect} from "react";

import IconCross from "@/assets/iconCross.svg?react";
import IconValide from "@/assets/iconValide.svg?react";
import Loader from "@/components/Loader/Loader";
import toast from "@/fonction/toast";
import type {UseLoadingStateReturn} from "@/hooks/useLoadingState/useLoadingState";

import {Button, type ButtonProps} from "./Button";

export function ButtonForFetch({
  loadingState,
  icon,
  label,
  labelLoading = "Enregistrement...",
  labelError = "Erreur",
  labelSuccess = "Enregistrer",
  messageSuccess = "Envoi effectué avec succès",
  messageError = "Erreur lors de l'envoi",
  disbaled = false,
  variant = "secondary",
  onClick = () => {
    return Promise.resolve();
  },
  ...reste
}: {
  loadingState: UseLoadingStateReturn;
  messageSuccess: string;
  messageError: string;
  icon: ReactElement;
  label: string;
  labelLoading: string;
  labelError: string;
  labelSuccess: string;
  disbaled?: boolean;
  variant?: string;
  onClick?: () => Promise<void>;
} & ButtonProps): ReactElement {
  useEffect(() => {
    if (loadingState.isSuccess) {
      toast(messageSuccess, 3000, "validate");
      setTimeout(() => {
        loadingState.reset();
      }, 3000);
    } else if (loadingState.hasError) {
      toast(loadingState.error || messageError, 3000, "alert");
      setTimeout(() => {
        loadingState.reset();
      }, 3000);
    }
  }, [loadingState, messageSuccess, messageError]);

  return (
    <Button
      label={`${loadingState.isLoading ? labelLoading : loadingState.hasError ? labelError : loadingState.isSuccess ? labelSuccess : label}`}
      disabled={loadingState.isLoading || disbaled}
      icon={
        loadingState.isLoading ? (
          <Loader isIcon={true} color="white" />
        ) : loadingState.hasError ? (
          <IconCross />
        ) : loadingState.isSuccess ? (
          <IconValide />
        ) : (
          icon
        )
      }
      variant={
        loadingState.hasError
          ? "alerte"
          : loadingState.isSuccess
            ? "validate"
            : variant
      }
      onClick={onClick}
      {...reste}
    />
  );
}
